import { useState, useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import { FaFilter } from "react-icons/fa";
import { Star } from "lucide-react";
import { RxCross2 } from "react-icons/rx";
import { RiArrowDropDownLine } from "react-icons/ri";

export default function SearchBar({
  rating,
  setRating,
  featured,
  setFeatured,
  applyFilter,
  order,
  setOrder,
  searchTerm,
  setSearchTerm,
  // clearFilters,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [filtersApplied, setFiltersApplied] = useState(0);

  const updateFiltersApplied = () => {
    let count = 0;
    if (featured) count++;
    if (rating) count++;
    if (order.entity !== "createdAt" || order.sortBy !== "desc") count++;
    setFiltersApplied(count);
  };

  useEffect(() => {
    updateFiltersApplied();
  }, [featured, rating, order]);

  const handleRatingClick = (selectedRating) => {
    setRating(selectedRating === rating ? "" : selectedRating);
    console.log(selectedRating);
  };

  const handleOrderChange = (field, sortBy) => {
    setOrder({ entity: field, sortBy });
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      applyFilter();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-4 justify-between md:w-[90%] relative">
      <div className="flex justify-center items-center gap-4 border bg-white py-2 px-4 rounded-full m-auto md:m-0 w-[80vw] md:w-72">
        <div onClick={applyFilter} className="cursor-pointer">
          <FiSearch size={20} color="#878787" />
        </div>
        <input
          className="flex-1 focus-visible:border-none focus:border-none focus-within:border-none outline-none"
          type="text"
          placeholder={"Search by Consultation Id"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>

      <div className="relative ml-[7vw] w-48" ref={dropdownRef}>
        <div>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="px-4 py-2 border rounded-full flex items-center justify-around gap-2 text-[#8B909A] border-none bg-white"
          >
            Filter {filtersApplied > 0 && <span>({filtersApplied})</span>}
            {/* <FaFilter className="ml-2" /> */}
            <RiArrowDropDownLine />
          </button>
        </div>
        {dropdownOpen && (
          <div className="absolute mt-2 bg-gray-100 border rounded-lg shadow-lg border-gray-300 z-10">
            <div className="flex flex-wrap gap-2 p-2 m-1 bg-white rounded-lg">
              <div
                className={` flex flex-row gap-2 items-center px-2 py-1 rounded-md cursor-pointer ${
                  featured == true
                    ? "bg-orange-50 border border-orange-500"
                    : "bg-gray-100 border border-blue-200"
                }`}
                onClick={() => setFeatured(!featured)}
              >
                <p>Featured only</p>
                {featured ? <RxCross2 size={16} /> : ""}
              </div>
            </div>

            <div className="p-2 m-1 rounded-lg bg-white px-2">
              <div className="mb-2">Order by</div>
              <label htmlFor="recentlyAdded" className="cursor-pointer">
                <div className="flex items-center mt-2 justify-between px-2">
                  Recently Added
                  <input
                    className="cursor-pointer"
                    type="radio"
                    id="recentlyAdded"
                    name="sort"
                    value="createdAt"
                    checked={
                      order.entity === "createdAt" && order.sortBy === "desc"
                    }
                    onChange={() => handleOrderChange("createdAt", "desc")}
                  />
                </div>
              </label>

              <label htmlFor="topRated" className="cursor-pointer">
                <div className="flex items-center mt-2 justify-between px-2">
                  Top Rated
                  <input
                    type="radio"
                    id="topRated"
                    name="sort"
                    value="rating"
                    checked={
                      order.entity === "rating" && order.sortBy === "desc"
                    }
                    onChange={() => handleOrderChange("rating", "desc")}
                  />
                </div>
              </label>

              <label htmlFor="lowestRated" className="cursor-pointer">
                <div className="flex items-center mt-2 justify-between px-2">
                  Lowest Rated
                  <input
                    type="radio"
                    id="lowestRated"
                    name="sort"
                    value="rating"
                    checked={
                      order.entity === "rating" && order.sortBy === "asc"
                    }
                    onChange={() => handleOrderChange("rating", "asc")}
                  />
                </div>
              </label>
            </div>

            <div className="p-2 m-1 rounded-lg bg-white">
              <div className="mb-2">Filter by stars</div>
              <div className="flex flex-wrap gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div
                    key={star}
                    className={`flex flex-row justify-center items-center gap-2 cursor-pointer px-1 rounded-md ${
                      rating == star
                        ? "bg-orange-50 border border-orange-500"
                        : "bg-gray-200 border border-orange-50"
                    }`}
                    onClick={() => handleRatingClick(star)}
                  >
                    {star}
                    <Star
                      size={18}
                      className={"text-yellow-400 fill-current"}
                    />
                  </div>
                ))}
              </div>
            </div>

            <div className="flex items-center justify-center w-full my-2">
              <button
                onClick={() => {
                  applyFilter();
                  setDropdownOpen(false);
                }}
                className="px-2 py-1 bg-primary text-white rounded-full text-sm"
              >
                Apply Filters
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
